import { StandardEvents } from '@shopify/events';

let cartRequest;

function fetchCartCount() {
  if (!cartRequest) {
    const root = window.Shopify?.routes?.root || '/';
    cartRequest = fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        return response.json();
      })
      .then((cart) => cart.item_count)
      .finally(() => { cartRequest = undefined; });
  }
  return cartRequest;
}

class YeefineCartCount extends HTMLElement {
  #revision = 0;

  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
  }

  disconnectedCallback() {
    this.#revision++;
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onCartUpdate = async (event) => {
    const revision = ++this.#revision;
    try {
      let count;
      if (event.promise) {
        const result = await event.promise;
        count = result.cart?.totalQuantity ?? result.cart?.item_count;
      }
      if (!Number.isInteger(count) || count < 0) count = await fetchCartCount();
      this.updateCount(count, revision);
    } catch {}
  };

  onPageShow = async (event) => {
    if (!event.persisted) return;
    const revision = ++this.#revision;
    try {
      this.updateCount(await fetchCartCount(), revision);
    } catch {}
  };

  updateCount(count, revision) {
    if (revision !== this.#revision || !this.isConnected || !Number.isInteger(count) || count < 0) return;
    this.textContent = String(count);
  }
}

if (!customElements.get('yeefine-cart-count')) {
  customElements.define('yeefine-cart-count', YeefineCartCount);
}
